import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import VeeValidate from 'vee-validate'
import firebase from 'firebase/app'
import 'firebase/auth'
import AlertCmpt from './components/Shared/Alert'

Vue.config.productionTip = false

const validationConfig = {
  aria: true,
  classNames: {},
  classes: false,
  delay: 0,
  dictionary: null,
  errorBagName: 'errors', // change if property conflicts
  events: 'input|blur',
  fieldsBagName: 'fields',
  i18n: null, // the vue-i18n plugin instance
  i18nRootKey: 'validations', // the nested key under which the validation messages will be located
  inject: true,
  locale: 'en',
  validity: false
}

Vue.use(VeeValidate, validationConfig)

Vue.component('mikro-alert', AlertCmpt)

new Vue({
  router,
  store,
  render: h => h(App),
  created () {
    firebase.initializeApp({
      apiKey: 'AIzaSyCTFgQJDx9JZ0gvOsGpOr3p78EfdcpiBE8',
      authDomain: 'fire-mikrojournal.firebaseapp.com',
      databaseURL: 'https://fire-mikrojournal.firebaseio.com',
      projectId: 'fire-mikrojournal',
      storageBucket: 'fire-mikrojournal.appspot.com',
      messagingSenderId: '70467427207'
    })
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        store.dispatch('autoSignIn', user)
        store.dispatch('getAddressBook', user.uid)
      }
    })
  }
}).$mount('#app')
